var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TwitterIcon } from '@web/components/ui/icons/TwitterIcon';
import { helpCenterUrl, privacyPolicyUrl, statusUrl, termsOfServiceUrl, X_AccountUrl } from '@web/router/urls';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
var Footer = function () {
    var t = useTranslation().t;
    var footerLinks = [
        { id: 1, name: t('footer.helpCenter'), to: helpCenterUrl },
        { id: 2, name: t('footer.privacyPolicy'), to: privacyPolicyUrl },
        { id: 3, name: t('footer.termsOfService'), to: termsOfServiceUrl },
        { id: 4, name: t('footer.status'), to: statusUrl },
        {
            id: 5,
            to: X_AccountUrl,
            icon: _jsx(TwitterIcon, { width: "20", height: "20" }),
            isIcon: true
        }
    ];
    return (_jsx("footer", __assign({ className: "py-14 text-gray-400" }, { children: _jsxs("div", __assign({ className: "flex flex-wrap gap-10 items-center justify-between" }, { children: [_jsxs("div", __assign({ className: "flex flex-col text-xs gap-3" }, { children: [_jsx("p", __assign({ className: "font-normal text-base" }, { children: _jsx(Trans, { t: t, i18nKey: "footer.rightsReserved", values: {
                                    year: new Date().getFullYear()
                                } }) })), _jsx("p", { children: t('footer.workalizerOwnershipNotice') }), _jsx("p", { children: t('footer.googleOwnershipNotice') })] })), _jsx("nav", __assign({ "aria-label": "Footer" }, { children: _jsx("ul", __assign({ className: "flex flex-wrap gap-10 text-base items-center" }, { children: footerLinks.map(function (link) {
                            return link.isIcon ? (_jsx("li", __assign({ className: "ml-5" }, { children: _jsx(Link, __assign({ to: link.to, className: "text-gray-400 hover:text-gray-500" }, { children: link.icon })) }), link.id)) : (_jsx("li", { children: _jsx(Link, __assign({ to: link.to, className: "text-gray-400 hover:text-gray-500" }, { children: link.name })) }, link.id));
                        }) })) }))] })) })));
};
export default Footer;
